import React, { Component } from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Dialog from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Dialog';
import DialogTitle from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogTitle';
import DialogContent from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogContent';
import DialogActions from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogActions';
import { noop } from 'Helpers/PropTypes';
import PropTypes from 'prop-types';
import { QueryFirstChild } from 'Helpers/Dom';

const buildOnKeyDown = onCtrlEnter => (e) => {
  // NH - windows (ctrlKey+13), mac (metaKey+13)
  if (e.keyCode === 13 && (e.ctrlKey || e.metaKey)) {
    onCtrlEnter();
  }
};

const styles = () => ({
  dialogPaper: {
    width: '100%',
  },
});

const AddListenerChildren = (children, onCtrlEnter) => React.Children.map(children, (c) => {
  const currOnKeyDown = (c.props && c.props.onKeyDown) || noop;
  const combinedOnKeyDown = (e) => {
    buildOnKeyDown(onCtrlEnter)(e);
    currOnKeyDown(e);
  };
  return React.cloneElement(c, {
    onKeyDown: combinedOnKeyDown,
  });
});

class HeaderFooterModal extends Component {
  constructor(props) {
    super(props);

    this.innerRef = React.createRef();
    this.onOpened = this.onOpened.bind(this);
  }

  onOpened() {
    if (this.innerRef.current) {
      const firstInput = QueryFirstChild(this.innerRef.current, 'textarea');
      if (firstInput) {
        firstInput.focus();
      }
    }
  }

  render() {
    const {
      isOpen,
      onClose,
      size,
      classes,
      className,
      header,
      headerText,
      children,
      footer,
      onCtrlEnter,
      zIndex,
    } = this.props;
    return (
      <Dialog
        zIndex={zIndex}
        open={isOpen}
        onClose={onClose}
        size={size}
        className={className}
        classes={{
          root: className,
          paper: classes.dialogPaper,
        }}
        innerRef={this.innerRef}
      >
        <DialogTitle>
          {header}
          {headerText && <span>{headerText}</span>}
        </DialogTitle>
        <DialogContent>{AddListenerChildren(children, onCtrlEnter)}</DialogContent>
        <DialogActions>{footer}</DialogActions>
      </Dialog>
    );
  }
}

HeaderFooterModal.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool,
  size: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  header: PropTypes.node,
  headerText: PropTypes.string,
  footer: PropTypes.node,
  onClose: PropTypes.func,
  onCtrlEnter: PropTypes.func,
  zIndex: PropTypes.number,
};

HeaderFooterModal.defaultProps = {
  isOpen: false,
  size: undefined,
  className: 'Modal',
  header: null,
  headerText: '',
  footer: null,
  onClose: noop,
  onCtrlEnter: noop,
  zIndex: undefined,
};

export default withStyles(styles)(HeaderFooterModal);
